import { ReactElement } from 'react'
import Card from 'react-bootstrap/Card'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import {
  ListItem,
  CardHeader,
  CardWrapper,
  Loader
} from '../../../../components'
import { SubjectImage, ListItemWrapper } from './subcomponents'
import { getSubjectLogo, capitalize } from '../../../../helpers'
import strings from '../../../../locale/en'
import { RootState } from '../../../../redux/store'
import ROUTES from '../../../../const/routes'
import { useHistory } from 'react-router-dom'
import BREAKPOINTS from '../../../../const/breakpoint'
import useBreakpoint from 'use-breakpoint'
import { getSessions } from '../../../../redux/live/action'

const CompletedSessions = (): ReactElement => {
  const {
    isLoading,
    sessions,
    isMenuOpen,
    batchList = [],
    branchList = [],
    coachingCentreId = ''
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.live?.isLoading,
      sessions: state.live?.completedSessions,
      isMenuOpen: state.menu.isMenuOpen,
      batchList: state.user?.userInfo?.userDetail?.batchList,
      branchList: state.user?.userInfo?.userDetail?.branchList,
      coachingCentreId: state.user?.userInfo?.userDetail?.coachingCentre?.id
    }),
    shallowEqual
  )

  const dispatch = useDispatch()
  const batchIds = batchList.map((batch) => batch.id)
  const branchIds = branchList.map((branch) => branch.id)
  const requestDate = {
    batchIds,
    branchIds,
    coachingCentreId
  }
  const {
    live: { completedSession }
  } = strings
  const history = useHistory()
  const { breakpoint } = useBreakpoint(BREAKPOINTS)

  const onSelectHandler = (subjectId: string, subjectName: string) => {
    dispatch(getSessions({ ...requestDate, subjectId }))
    history.push({
      pathname: ROUTES.COMPLETED_SESSIONS,
      state: {
        name: subjectName
      }
    })
  }

  return (
    <CardWrapper>
      <CardHeader>{completedSession}</CardHeader>
      <Card.Body>
        {isLoading ? (
          <Loader />
        ) : (
          sessions.length > 0 && (
            <ListItemWrapper>
              {sessions.map((session, index) => {
                const { courseName, id, parentName = '' } = session
                return (
                  <ListItem
                    key={`completedSession-${index}`}
                    title={capitalize(courseName)}
                    index={index}
                    isMobileMenuOpen={isMenuOpen && breakpoint === 'mobile'}
                    icon={
                      <SubjectImage
                        src={getSubjectLogo({
                          subject: courseName
                        })}
                      />
                    }
                    onSelect={() => onSelectHandler(id, courseName)}
                    subTitle={parentName}
                  />
                )
              })}
            </ListItemWrapper>
          )
        )}
      </Card.Body>
    </CardWrapper>
  )
}

export default CompletedSessions
